import React from 'react';
import "./custom.css";
import logo from './img/images/logo-white-new.png';
import bannerimg from './img/images/header-circle-img.jpg';
import certificate from './img/images/certificate.jpg';
import alllogo from './img/images/all-logos.jpg';
import businessapp from './img/images/icons/businessapp.png';
import dashboard from './img/images/dashboard.jpg';
import dashboard1 from './img/images/dashboard1.jpg';
import orgteamchart from './img/images/org-team-chart.jpg';
import orgteamchart1 from './img/images/org-team-chart1.jpg';
import goalmangment from './img/images/goal-mangment.jpg';
import analyticsreprighticoncolor from './img/images/analytics-rep-right-icon-color.png';
import { Link } from 'react-router-dom';
export default function Homepage() {

  function handleScroll() {
    window.scroll({
      top: document.body.scrollHeight,
      left: 0, 
      behavior: 'smooth',
    });
  }

  return (
   <>
 <nav className="navbar transparent-bg">
     
     <div className="container">
      
       <Link className="navbar-brand"><img src={logo} alt='logo'/></Link>
       <ul className="navbar-nav ms-auto navbar-custom">
         {/* <!-- <li className="nav-item">
           <a className="nav-link" aria-current="page" href="#">Home</a>
         </li> --> */}
         <li className="nav-item">
           {/* <!-- <a className="nav-link" href="https://first-lsi-consulting-pvt-ltd-sustainabilitypro-4r7t5hgs765fb1dc.cfapps.us10-001.hana.ondemand.com/sustainabilitypro/index.html">Business App</a> --> */}
           <Link className="nav-link" href="/app">Business App</Link>
         </li>
         {/* <!-- <li className="nav-item">
           <a className="nav-link" href="https://first-lsi-consulting-pvt-ltd-sustainabilitypro-4r7t5hgs52395f1d.cfapps.us10-001.hana.ondemand.com/enterprisesustainabilitypro/index.html">Enterprise Management</a>
         </li> --> */}
       </ul>
     
       <form className="d-flex" role="search">
        <Link onClick={handleScroll} className="btn get-in-touch-btn" type="submit">GET IN TOUCH</Link>
       </form>
       {/* <!-- <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidenavbar" aria-controls="sidenavbar">
         <span className="navbar-toggler-icon"></span>
       </button> --> */}
       {/* <!-- <div className="offcanvas offcanvas-end text-bg-dark" tabindex="-1" id="sidenavbar" aria-labelledby="sidenavbarLabel">
         <div className="offcanvas-header">
           <h5 className="offcanvas-title" id="sidenavbarLabel"><img src="images/logo-white.png"></h5>
           <button type="button" className="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
         </div>
         <div className="offcanvas-body">
           <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
             <li className="nav-item">
               <a className="nav-link active" aria-current="page" href="#">Home</a>
             </li>
             <li className="nav-item">
               <a className="nav-link" href="#">Link</a>
             </li>
             <li className="nav-item dropdown">
               <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                 Dropdown
               </a>
               <ul className="dropdown-menu dropdown-menu-dark">
                 <li><a className="dropdown-item" href="#">Action</a></li>
                 <li><a className="dropdown-item" href="#">Another action</a></li>
                 <li>
                   <hr className="dropdown-divider">
                 </li>
                 <li><a className="dropdown-item" href="#">Something else here</a></li>
               </ul>
             </li>
           </ul>
           <form className="d-flex mt-3" role="search">
             <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search">
             <button className="btn btn-success" type="submit">Search</button>
           </form>
         </div>
       </div> --> */}
     </div>
   
   </nav>

   <div className="container-fluid">
        <div className="row">
           
        <div className="header-section">
            <div className="container">
            <div className="header-left-section">
             <h1>Sustainability Goal Management & Monitoring @ ease of click</h1>
             <p>A first of its kind, end to end solution to manage Sustainability
                across organizations, regions, and hierarchies with both Internal & 
                External (Supply chain) stakeholders</p>
            <p>A first of its kind, end to end solution to manage Sustainability
                    across organizations, regions, and hierarchies with both Internal & 
                    External (Supply chain) stakeholders</p>
                    <Link className="btn get-in-touch-btn big-btn" type="submit">REQUEST A DEMO</Link>
                </div>
                <div className="header-right-section">
                    <img src={bannerimg} alt='banner-img'/>
                </div>

            </div>
        </div>
    
    </div>
    </div>

    <section className="border-section">
    <div className="container">
        <div className="apptype">
        <p>Suspro.io is a SAAS platform integrated with various Analytical tools and SAP solutions focusing Sustainability process for enterprises who can be client or supplier. Outline of the features are illustrated:</p>
       <div className="awards">
        <div className="row">
         <div className="col-sm-6">
          <h4>Happy to share that<span> LSInextGen </span> won an award at recent <span>  Electric Utility Industry Sustainable Supply Chain Alliance (EUISSCA)SSCA</span>  Conference at Arizona, USA.</h4>
         <p>We are 2022 EUISSCA Sustainable Supply Chain Case Study Award Winner for one of our innovative solution to manage sustainability end to end by streamlining the current business problem faced by organisations hence helps in reducing cost, time and errors through process automation!</p>
        </div>
        <div className="col-sm-6">
        <div className="img-certiifcate">
          <img src={certificate} alt='certificate'/>
          <img src={alllogo} alt='alllogo'/>
        </div>
         
        </div>
      
        </div>
       </div>
       <div className="apptab">
        <div className="appcard" onclick="openAppTab(event, 'businessapp')" id="defaultOpen">
            <div className="appicon">
                <img src={businessapp} alt='businessapp'/>
               <span>Sustainability Pro App</span> 
            </div>
            <div className="content">
                <p>This App will help to create, manage & assign new sustainability goals across organization and stake holders. Also you can get Customized Reports & Analytics. You can manage Org structure for Sustainability goals. This App helps you to achieve sustainability goals effectively.</p>
            </div>
            {/* <!-- <a href="https://first-lsi-consulting-pvt-ltd-sustainabilitypro-4r7t5hgs765fb1dc.cfapps.us10-001.hana.ondemand.com/sustainabilitypro/index.html" className="btn-grey">LAUNCH APP</a> --> */}
            <Link className="btn-grey">LAUNCH APP</Link>
        </div>
        {/* <!-- <div className="appcard" onclick="openAppTab(event, 'enterpmanagmt')">
            <div className="appicon">
                <img src="images/icons/enterpmanagmt.png">
               <span>Enterprise Management</span> 
            </div>
            <div className="content">
                <p>This application is meant for Enterprise self-service administration
                  to manage Team, Department, Employees, Supplier partners,
                  customization of Goal templates, report structuring and various
                  configurations in order to support the Business App.</p>
            </div>
            <a href="https://first-lsi-consulting-pvt-ltd-sustainabilitypro-4r7t5hgs52395f1d.cfapps.us10-001.hana.ondemand.com/enterprisesustainabilitypro/index.html" className="btn-grey">LAUNCH APP</a>
        </div> --> */}
      </div>
    </div>

    </div>
   </section>

   <div className="businessapp tabcontent" id="businessapp">
   <section className="grey-bg">
    <div className="container">
    <div className="row">

  <div className="col-sm-12">
    <div className="dashboard">
      <h3>Reports and Dashboard</h3>
      <p>This is a user experience driven Dashboard with dynamic filter,
       navigation and drilldown features, Goals of each stakeholder is
       compared to what they achieve in real-time with comprehensive analytics.</p>
       <h4>Features to be presented here</h4>
       <ul>
        <li>Goal creations and management</li>
        <li>Import Reports and consolidation</li>
        <li>Report template creation</li>
        <li>Export of reports as in desired structure</li>
        <li>Analytics on various key drivers, department, team etc.</li>
       </ul>
    </div>
   </div>
   </div>
   <div className="row">
   <div className="col-sm-6">
    <div className="dashboard">
    <img src={dashboard} alt='dashboard' className="img-fluid"/>
    </div>
   </div>
   <div className="col-sm-6">
    <div className="dashboard">
    <img src={dashboard1} alt='dashboard1' className="img-fluid"/>
    </div>
   </div>
  </div>
</div>
   </section>


   <section className="white-bg">
    <div className="container">
  
   <div className="row">
   <div className="col-sm-12">
    <div className="dashboard">
      <h3>Org. Team Chart &amp; KPI</h3>
      <p>This feature enables Department Head/Team Leads to view team hierarchy and easily monitor status of each member
        accomplishment of task assigned in a single Hierarchy chart and also able to navigate to related information.</p>
       <h4>Features Enabled:</h4>
       <ul>
       <li>Organization structure</li> 
       <li>Team Hierarchy</li> 
        <li>Team KPI Card with Key indicators</li> 
          <li>Navigation to further details</li> 
       </ul>
    </div>
   </div>
  </div>
  <div className="row">
    <div className="col-sm-6">
     <div className="dashboard">
     <img src={orgteamchart} alt='orgteamchart' className="img-fluid"/>
     </div>
    </div>
    <div className="col-sm-6">
      <div className="dashboard">
      <img src={orgteamchart1} alt='orgteamchart1' className="img-fluid"/>
      </div>
     </div>
    </div>
</div>
   </section>

   <section className="grey-bg">
    <div className="container">
    <div className="row">

  <div className="col-sm-6">
    <div className="dashboard">
      <h3>Goal Management</h3>
      <p>Sustainability Goal Management is the core function in the System that helps Enterprise to design goal template and assign goals to different stakeholders and monitor progress, generate reports and analytics.</p>
       <h4>Features:</h4>
       <ul>
       <li>Create Goal Template [ Filed customization]</li> 
       <li> Create Goal</li> 
        <li>Assign Goal to Employees and Suppliers</li> 
        <li> Update progress by stakeholders</li> 
        <li> Administrate goal (enhance/delete)</li> 
        <li> Run Analytics</li> 
        <li>  Generate Reports</li> 
       </ul>
    </div>
   </div>
   <div className="col-sm-6">
    <div className="dashboard">
    <img src={goalmangment} alt='goalmangment' className="img-fluid"/>
    </div>
   </div>
  </div>
</div>
   </section>

   {/* <!-- <section className="white-bg">
    <div className="container">
    <div className="row">
      <div className="col-sm-6">
        <div className="dashboard">
        <img src="images/maintain-supplier.jpg" className="img-fluid">
        </div>
       </div>
   <div className="col-sm-6">
    <div className="dashboard">
      <h3>Maintain Supplier</h3>
      <p>This Feature will help enterprise to register supplier, assign goals,
        monitor progress, import report, export consolidated report etc.</p>
       <h4>Features Enabled:</h4>
       <ul>
       <li>Add Suppler</li> 
       <li> Assign Goal</li>
       <li> Track progress</li>
       <li> Import reports</li>
       <li>Export reports</li>
       </ul>
    </div>
   </div>
 
  </div>
</div>
   </section> --> */}

   <section>
    <div className="container">
     
        <div className="analytics-and-reports">
          <div className="left">  
            <h3>Analytics and reports </h3>
            <h4>Compliance & Reporting</h4>
            <ul>
             <li> Reports can be auto generated for Internal Auditing purposes</li>
             <li>Auto-generation of external compliance reports for all industries like GRI, FASB, SASB, ESG, CDP</li>
            </ul> 
          </div>
          <div className="right"> 
    <img src={analyticsreprighticoncolor} alt='analytics-rep-right-icon-color'/>
    </div>
  </div>
    </div>
    </section>
  </div>
{/* 
  <div className="enterprise-management tabcontent" id="enterpmanagmt">
    <section className="grey-bg">
      <div className="container">
      <div className="row">
  
    <div className="col-sm-6">
      <div className="dashboard mt-5">
        <h3>Setup your Enterprise Account
          with multiple users</h3>
        <p>You can setup your Enterprise subscription and add users from your organization to use the Business application. You can also setup your organization profile, update contact details etc.,</p>
    
      </div>
     </div>
     <div className="col-sm-6">
      <div className="dashboard">
      <img src={setupenterpriseaccount} className="img-fluid"/>
      </div>
     </div>
    </div>
  </div>
     </section>
  
  
     <section className="white-bg">
      <div className="container">
      <div className="row">
     <div className="col-sm-6">
      <div className="dashboard">
      <img src="images/user-role-mang.jpg" className="img-fluid"/>
      </div>
     </div>
     <div className="col-sm-6">
      <div className="dashboard">
        <h3>User, Role, Custom Role Management</h3>
        <p>This feature enables Department Head/Team Leads to view team hierarchy and easily monitor status of each member
          accomplishment of task assigned in a single Hierarchy chart and also able to navigate to related information.</p>
         <h4>What you can do</h4>
         <ul>
         <li> Add user-Internal/External</li>
         <li>  Assign Role for accessing each option in business APP</li>
         <li> Grant/restrict privileges to access Goal, reports etc.,</li>
         <li> Create Departments</li>
         <li> Import user list through excel template instead of creating one by one</li>
         
          <li> Add external users from Supply chain partners</li>
            <li> Manage users - suspend, activate, delete etc.,</li>
              <li> Complete Authorization and role management</li>
                <li> Request for Custom Roles</li>
         </ul>
      </div>
     </div>
    </div>
  </div>
     </section>
  
     <section className="grey-bg">
      <div className="container">
      <div className="row">
  
    <div className="col-sm-6">
      <div className="dashboard">
        <h3>Supplier/Supply Chain partner Management</h3>
        
        <p>This function will help you to add your Supply Chain partners and its resources for Goal detail updation, report sharing etc.,</p>
         <h4>What you can do</h4>
         <ul>
         <li> Add your Supply Chain Partner</li>
         <li> Add/Manage Supplier resources</li>
          <li> Enable report and Goal updations</li>
          <li> Assign Roles and Privileges</li>
          <li> Enable tracking</li>
          <li>  Manage Supplier partner- Activate, Suspend Delete</li>
         </ul>
      </div>
     </div>
     <div className="col-sm-6">
      <div className="dashboard">
      <img src="images/supplier-chain-partner.jpg" className="img-fluid"/>
      </div>
     </div>
    </div>
  </div>
     </section>
  
     <section className="white-bg">
      <div className="container">
      <div className="row">
        <div className="col-sm-6">
          <div className="dashboard">
          <img src="images/customize-goal.jpg" className="img-fluid"/>
          </div>
         </div>
     <div className="col-sm-6">
      <div className="dashboard">
        <h3>Customize Goal, Report
          Templates</h3>
        <p>Here you can define your formats/data fields for Goal data capture and set report templates etc.</p>
         <h4>What you can do</h4>
         <ul>
         <li> Add Goal templates </li>
          <li>  Add report templates</li>
            <li> Request for customization of reports/templates</li>
         </ul>
      </div>
     </div>
   
    </div>
  </div>
     </section>
  
     <section className="grey-bg">
      <div className="container">
      <div className="row">
  
    <div className="col-sm-6">
      <div className="dashboard mt-5">
        <h3>Setup your Organization Profile &
          Many more</h3>
        
          <p>This function helps you to setup your organization profile, master
          data codes and various other customized information including
          subdomain (in future).</p>
          
          <p>There are many other features and you are requested to contact our Enterprise account support for more information</p> 
      </div>
     </div>
     <div className="col-sm-6">
      <div className="dashboard">
      <img src="images/org-profile-setup.jpg" className="img-fluid"/>
      </div>
     </div>
    </div>
  </div>
     </section>
  
  
  </div> */}

  {/* <!-- <section className="our-client">
      <div className="container">
        <div className="client-list">
          <h3>Our Clients</h3>
          <div className="owl-carousel ourclients-slide">
            
           <img src="images/clients-logo/client-list.png">
           <img src="images/clients-logo/client-list.png">
           <img src="images/clients-logo/client-list.png">
           <img src="images/clients-logo/client-list.png">

      
          </div>
        </div>
  
      </div>
      </section> -->

      <!-- <section>
        <div className="container">
          <div className="testimonials">
            <h3>Testimonials</h3>
            <div className="owl-carousel testimonials-slides">
       
  
            </div>
          </div>
    
        </div>
        </section> -->

        <!-- <section>
          <div className="container">
            <div className="testimonials">
              <h3>Testimonials</h3>
              <div className="main-content">
                <div className="owl-carousel owl-theme">
                  <div className="testimonials-cards">
                    <div className="testimonial-profile-pic">
                    <img src="images/testimonial-profile.png">
                    </div>
                    <div className="testimonials-user">
                       <h3>Name</h3>
                       <span>Designation</span>
                       <span>Company Name</span>
                      
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                  </div>
                  <div className="testimonials-cards">
                    <div className="testimonial-profile-pic">
                    <img src="images/testimonial-profile.png">
                    </div>
                    <div className="testimonials-user">
                       <h3>Name</h3>
                       <span>Designation</span>
                       <span>Company Name</span>
                      
                    </div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                  </div>
                   
                  
                </div>
                <div className="owl-theme">
                    <div className="owl-controls">
                        <div className="custom-nav owl-nav"></div>
                    </div>
                </div>
            </div>
            </div>
      
          </div>
          </section> --> */}

<section id="getintouch">
            <div className="container d-flex justify-content-center">
              <div className="col-sm-8">
              <div className="getintouch-form">
                <h3>Get in Touch</h3>
                <div className="row mb-3">
                  
                  <div className="col-xs-12 col">
                    <input type="text" className="form-control" placeholder="Name" aria-label="Name"/>
                  </div>
                  <div className="col-xs-12 col">
                    <input type="email" className="form-control" placeholder="Email" aria-label="Email"/>
                  </div>
                  <div className="col-xs-12 col">
                    <input type="text" className="form-control" placeholder="Phone" aria-label="Phone"/>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                   <textarea name="message" placeholder="Enter your message here" className="form-control" cols="30" rows="5"></textarea>
                  </div>
                </div>
                <div className="row ">
                  <div className="col d-flex justify-content-center mt-3">
                    <Link href="#" className="form-btn"> Submit </Link>
                  </div>
                </div>
          
              </div>
            </div>
            </div>
          </section>

          <footer>
            <div className="top-footer">
              <div className="container">
              <div className="row">
                <div className="col-sm-4">
                  <div className="logo-socialmedia">
                    <img src="images/logo-white-new.png" alt="logo"/>
                    <ul className="social-media">
                     <Link ><i className="fa fa-facebook" ></i></Link>
                      <Link ><i className="fa fa-linkedin" ></i></Link>
                    </ul>
                  </div>
                </div>
                <div className="col-sm-8">
                  <div className="footerlinksmain">
                  <div className="footer-links">
                   <h4>Useful Links</h4>
                    <ul>
                     <li><Link href="#">Home</Link></li>
                     <li> <Link  href="#">About Us</Link></li>
                     <li> <Link  href="#">Services</Link></li>
                     <li> <Link  href="#">Blog</Link></li>
                     <li> <Link  href="#">Contact</Link></li>
                    </ul>
                  </div>
                  {/* <!-- <div className="footer-links">
                    <h4>Product Help</h4>
                     <ul>
                      <li><a href="#">Home</a></li>
                      <li> <a href="#">About Us</a></li>
                      <li> <a href="#">Services</a></li>
                      <li> <a href="#">Blog</a></li>
                      <li> <a href="#">Contact</a></li>
                     </ul>
                   </div> --> */}
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div className="footer-bottom">
              <span>© Copyright 2023 suspro.io, All rights reserved.</span>
            </div>
          </footer>

   </>
  )
}
